export default __webpack_public_path__ + "static/media/icon-menu-candidate-active.48dac39f.svg";